import { ActivatedRoute } from '@angular/router';
import { Component, HostListener, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { StorageService, ObservatoryService, UserService } from '@services/services.module';
import { ProjectsService } from '@services/projects/projects.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-time-recording',
  templateUrl: './time-recording.component.html',
  styleUrls: ['./time-recording.component.scss']
})
export class TimeRecordingComponent implements OnInit, OnDestroy {
  public userData: any;
  private subscriptions: Array<Subscription> = [];

  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private storage: StorageService,
    private observatory: ObservatoryService,
    private projectsService: ProjectsService,
    private _user: UserService,
  ) {
    //console.log("cargando componente TimeRecordingComponent");
    window.scrollTo(0, 0);
  }

  ngOnInit() {
//console.log("cargando componente TimeRecordingComponent");
    this.translate.get(this.activatedRoute.snapshot.data['title']).subscribe((res: string) => {
      this.titleService.setTitle(res);
    });

      this._user.setInit();
      this.subscriptions.push(
        this._user.getUserData().subscribe((data) => {
          //console.log("userData", data);
          if (data) {

            this.observatory.setData('userData', data);
            this.storage.set('userDataStorage', data);
            this.userData = data;

            // this.userData = this.storage.get('userDataStorage');

            this.projectsService.getProjects(this.userData.employeeNumber).subscribe((proyectData) => {
              //console.log("proyectos", proyectData);
              if (proyectData) {
                proyectData.sort((a, b) => {
                  if (a.description < b.description) { return -1; }
                  if (a.description > b.description) { return 1; }
                  return 0;
                });
                proyectData.map((item) => {
                  item.campoCompleto = item.sapId + ' ' + item.description;
                  item.Id = item.projectId;
                  return item;
                });
                this.observatory.setData('proyectos', proyectData);
                this.storage.set('listProjectsByEmployee', proyectData);
                this.storage.set('allProjects', true);
              }
            });

          }
        })
      );


  }

  getNotification(evt) {
  }

  /**
   * @name ngOnDestroy
   * @description Lifecycle hook
   */
  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }

  }

}
